export default __webpack_public_path__ + "static/media/4_SOA_OG10_CLASS_VI_&_OG11_CLASS_VIII.79c7ac94.pdf";